<template>
  <div class="special_detail">
    <div class="header_logo">
      <img :src="detailData.bannerPic" alt="" />
    </div>
    <!-- 标题信息栏，副文本 -->
    <div class="title">
      <p class="main_title">{{ detailData.name }}</p>
      <div v-show="!detailShow" class="desc">
        {{ detailData.summary }}
      </div>
      <div
        v-show="detailShow"
        v-html="detailData.specialIntroduce"
        class="desc_html"
      ></div>
      <div class="show_hidden" @click="openDetail">
        {{ detailShow ? '收起' : '展开' }}
        <i
          :class="['iconfont', detailShow ? 'icon-arrowup' : 'icon-arrowdown']"
        ></i>
      </div>
    </div>
    <div @touchmove="preLoad(getPre)">
      <div class="list_title">
        <img
          src="http://cdn.yxvzb.com/WEB/wx-master/images/gtfont.png"
          alt=""
        />
        <span class="title_talk">专家访谈</span>
      </div>
      <ul>
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="jump(item)"
          :class="[
            'list',
            'vux-1px-t',
            index === list.length - 1 ? 'vux-1px-b' : ''
          ]"
        >
          <div>
            <img :src="item.picUrl" alt="" />
          </div>
          <div>
            <p>{{ item.name }}</p>
            <p>{{ item.introduce }}</p>
          </div>
        </li>
      </ul>
      <p style="text-align:center;margin-top: 1rem" v-if="isShow">
        <inline-loading></inline-loading>
        <span
          style="vertical-align:middle;display:inline-block;font-size:14px;"
        >
          &nbsp;&nbsp;加载中
        </span>
      </p>
      <p
        style="text-align:center;margin-top: 1rem"
        v-else-if="!isShow && !list.length"
      >
        <span
          style="vertical-align:middle;display:inline-block;font-size:14px;"
        >
          &nbsp;&nbsp;暂无内容
        </span>
      </p>
    </div>
  </div>
</template>
<script>
import { facing } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';
export default {
  name: 'specialDetail',
  mixins: [loadMore],
  data() {
    return {
      detailData: {
        title: '',
        bannerPic: '',
        dataSummary: '',
        data: ''
      },
      list: [],
      params: {
        pageNo: 1,
        pageSize: 10
      },
      detailShow: false,
      loadFlag: true,
      isShow: true
    };
  },
  methods: {
    openDetail() {
      this.detailShow = !this.detailShow;
    },
    // 处理1行半溢出隐藏
    splitDesc(data) {
      if (data.length > 43) {
        this.detailData.dataSummary = data.slice(0, 42) + '...';
      } else {
        return data;
      }
    },
    jump(item) {
      if (item.skipType == 1) {
        this.$router.push({
          name: 'courseDetail',
          params: {
            id: item.skipId
          }
        });
      } else {
        this.$router.push({
          name: 'headlineDetail',
          params: {
            id: item.skipId
          },
          query: {
            type: 0
          }
        });
      }
    },
    getDetail(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        facing.initSpecial(data).then(res => {
          if (this.detailData.title != res.data.title) {
            this.detailData = res.data.data;
            this.splitDesc(this.detailData.dataSummary || '');
          }
          this.isShow = false;
          let resList = res.data.data.list.list;
          resList.filter(item => {
            this.list.push(item);
          });
          if (resList.length < this.params.pageSize) {
            this.loadFlag = false;
            return false;
          }
          this.params.pageNo++;
          this.loadFlag = true;
        });
      }
    },
    getPre() {
      this.getDetail(
        Object.assign(this.params, {
          id: this.$route.params.id
        })
      );
    }
  },
  computed: {},
  watch: {},
  components: {},
  created() {
    this.getPre();
  }
};
</script>
<style lang="less" scoped>
@import '../../../public/style/g.less';
.special_detail {
  .title {
    position: relative;
    padding: 0.53rem 0.4rem 0.98rem;
    font-size: 0.35rem;
    color: #484848;
    // margin-bottom: .4rem;
    .main_title {
      font-size: 0.45rem;
      color: #191919;
      font-weight: bold;
      .lineClamp(2);
    }
    .desc {
      margin-top: 0.21rem;
      min-height: 1.1rem;
    }
    .desc_html {
      margin-top: 0.21rem;
      border-bottom: 0.97rem solid #fff;
    }
    .show_hidden {
      position: absolute;
      right: 0.4rem;
      bottom: 0.95rem;
      display: flex;
      align-items: center;
      font-size: 0.32rem;
      color: #999999;
      i {
        margin-left: 0.1rem;
      }
    }
  }
  .list_title {
    padding: 0 0.4rem;
    display: flex;
    align-items: center;
    width: 100%;
    height: 1.2rem;
    img {
      margin-left: 0.15rem;
      width: 0.6rem;
      height: 0.55rem;
    }
    .title_talk {
      margin-left: 0.27rem;
      color: #4b4b4b;
      font-size: 0.43rem;
      font-weight: bold;
    }
  }
  ul {
    padding: 0 0.4rem;
    .list {
      display: flex;
      align-items: center;
      padding: 0.44rem 0;
      div:nth-of-type(1) {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32%;
        img {
          width: 2.32rem;
          height: 2.32rem;
          background-size: 100% 100%;
        }
      }
      div:nth-of-type(2) {
        display: flex;
        flex-direction: column;
        width: 68%;
        p {
          .lineClamp(2);
        }
        p:nth-of-type(1) {
          color: #161616;
          font-size: 0.4rem;
          font-weight: bold;
        }
        p:nth-of-type(2) {
          margin-top: 0.28rem;
          color: #484848;
          font-size: 0.32rem;
        }
      }
    }
  }
}
.header_logo {
  width: 100%;
  height: 4.4rem;
  background-size: 100% 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
